module.exports = __webpack_public_path__ + "static/media/mysizeid.09376724.png";